<app-layout>

  <app-header [headerNavVisible]="headerNavVisible"></app-header>

  <div class="car_detail_contents" id="contents" *ngIf="(car$ | async) as car; else carLoadingTemplate">

    <!-- breadcrumb -->
    <div class="breadcrumb_area">
      <ol class="breadcrumb_list" itemscope="itemscope" itemtype="http://schema.org/BreadcrumbList">
        <li class="breadcrumb_nav breadcrumb_nav1" itemprop="itemListElement" itemscope="itemscope"
          itemtype="http://schema.org/ListItem">
          <a href="{{ appUrl }}" itemprop="item">
            <span class="breadcrumb_text" itemprop="name">{{ lang | i18nSelect: strings.breadcrumb.home }}</span>
          </a>
          <meta itemprop="position" content="1">
        </li>
        <li class="breadcrumb_nav breadcrumb_nav2" itemprop="itemListElement" itemscope="itemscope"
          itemtype="http://schema.org/ListItem">
          <span class="gt">&gt;</span>
          <a routerLink="/" itemprop="item">
            <span class="breadcrumb_text" itemprop="name">{{ lang | i18nSelect: strings.breadcrumb.carList }}</span>
          </a>
          <meta itemprop="position" content="2">
        </li>
        <li *ngIf="car.brand !== null"
          class="breadcrumb_nav breadcrumb_nav3" itemprop="itemListElement" itemscope="itemscope"
          itemtype="http://schema.org/ListItem">
          <span class="gt">&gt;</span>
          <a [routerLink]="['/makes/' + car.brand.id]" itemprop="item">
            <span class="breadcrumb_text" itemprop="name">{{ car.brand.name }}</span>
          </a>
          <meta itemprop="position" content="3">
        </li>
        <li class="breadcrumb_nav">
          <span class="gt">&gt;</span>
          <span class="thispage">{{ car.name }}</span>
        </li>
      </ol>
    </div>
    <!-- breadcrumb -->

    <div class="page_box" id="carphoto">
      <div class="inner_contents_box" id="inner_carphoto">
        <div class="header_container" data-aos="fade-in">
          <div class="page_header">
            <div class="header_contents">
              <div class="inner_hcontents">
                <div class="car_photo {{ getCarLabelClassName(car) }}" [ngClass]="{'photolabel': (car.inTransaction || car.sold || car.previousPrice || car.new)}">

                  <div class="inner_car_photo">

                    <app-swiper-container class="swiper-container" [options]="swipeOptions" [pager]="false" [nextPrevButton]="false" #carSlider>
                      <ng-container *ngFor="let photo of car.photos">
                        <app-swiper-slide>
                          <figure>
                            <div class="car_photo"><img src="{{ photo.url }}" alt="{{ car.name }}" class="car_image" [ngClass]="{'will_change_transform': sliderProcessTransition$ | async }" width="1200" height="800" loading="lazy" /></div>
                            <div class="car_caption"><figcaption class="inner_car_caption">{{ photo.caption }}</figcaption></div>
                          </figure>
                        </app-swiper-slide>
                      </ng-container>
                    </app-swiper-container>

                    <div class="swiper-button-prev" [ngClass]="{'swiper-button-disabled': sliderPrevButtonDisabled}"></div>
                    <div class="swiper-button-next" [ngClass]="{'swiper-button-disabled': sliderNextButtonDisabled}"></div>

                  </div>

                  <div class="swiper-my-pagination swiper-pagination-clickable swiper-pagination-bullets">
                    <ng-container *ngFor="let thumb of car.photos; let i = index">
                      <button type="button" class="swipter-pagination-bullet" (click)="slideTo(i)" [ngClass]="{'swiper-pagination-bullet-active': currentSliderIndex === i}">
                        <img src="{{ thumb.url }}?w=120" alt="画像: {{ i }}" class="car_thumbnail" />
                      </button>
                    </ng-container>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page_box" id="cardetail">
      <div class="inner_contents_box inner_cardetail">

        <div class="page_header">
          <div class="inner_page_header" data-aos="fade-down">
            <h1 class="t_head txtalcenter">
              <span class="model_year" *ngIf="car.modelYear != 0 ">{{ car.modelYear }}{{ lang | i18nSelect: strings.car.modelYear }}</span>{{ car.name }}
            </h1>
          </div>
          <div class="sharebtn">
            <div class="inner_sharebtn flex_layout">
              <div class="sharelabel">SNS SHARE</div>
              <div class="sharesns twbtn">
                <a (click)="shareTwitter($event)" href="{{ twitterShareUrl }}" rel="nofollow"><img src="assets/img/btn_tw.png" width="30" alt="Twitter"></a>
              </div>
              <div class="sharesns fbbtn">
                <a (click)="shareFB($event)" href="{{ fbShareUrl }}" rel="nofollow"><img src="assets/img/btn_fb.png" width="30" alt="Facebook" /></a>
              </div>
            </div>
          </div>
        </div>

        <app-car-upper-price [car]="car" [lang]="lang" (sendAdsTelEvent)="sendAdsTelEvent($event)"></app-car-upper-price>

        <div class="cardesc">
          <div class="inner_cardesc_contents">
            <h2 class="t_head car_copy txtalcenter" *ngIf="car.copy !=''">{{ car.copy }}</h2>
            <div [innerHTML]="car.descriptionHtml | safeHTML" *ngIf="car.descriptionHtml != ''; else underConstructionTemplate"></div>
          </div>
        </div>

        <app-car-video *ngIf="car.movieUrl as movieUrl" [movieUrl]="movieUrl"></app-car-video>

        <app-car-spec [car]="car" [lang]="lang"></app-car-spec>

        <app-car-lower-price [car]="car" [lang]="lang" (sendAdsTelEvent)="sendAdsTelEvent($event)"></app-car-lower-price>

    </div>
  </div>

    <section *ngIf="lang == 'ja'">
      <div class="page_box posrelative" id="carzycaution">
        <div class="inner_contents_box" id="inner_carzycaution">
          <div class="page_header fix_center_small txtalcenter">
            <div class="inner_page_header inviewfadeIn inviewDown fadeIn Down" data-aos="fade-down">
              <h2 class="t_head"><span class="icon_info"><img src="assets/img/icon_caution.png" srcset="assets/img/icon_caution.png 1x, assets/img/icon_caution@2x.png 2x" width="40" height="40" alt="説明"></span>CARZYご利用にあたっての<span class="dispinlineblock">注意事項</span></h2>
              <p class="t_read">CARZYはコレクタブルカーの個人間売買サービスです。掲載されている車両は売り主さまが所有されており、弊社の管理下にはありません。下記の注意事項をよくご理解の上でご覧くださいませ。</p>
            </div>
          </div>
          <div class="caution_contents fix_center">
            <div class="inner_caution_contents">
              <ul>
                <li>レポートは売り主さまへのヒアリングと現車の視認を元に構成されており、必ずしも掲載内容の裏付けが取れている訳ではありません。CARZYは掲載内容の正確性・無謬性を何ら保証しません。</li>
                <li>車両の状態を専門的にチェックしているわけではありませんので、何らかの不具合や故障が含まれる場合があります。また取材から日にちが経過することによる状態変化もあり得ます。掲載情報はあくまでも参考情報であることをご理解いただき、購入に際してはご自身の車両状態チェックとご判断を優先ください。</li>
                <li>品質チェックのために車体品質検査をご利用いただけます。<br><div class="btn_more smallbtn_more"><a href="{{ appUrl }}/about-carzy#carzyjudge">車体品質検査オプション</a></div></li>
                <li>個人間売買サービスの性質上、消費税は不要ですが、売り主が法人の場合は消費税の取り扱いを売り主さまとご相談ください。原則としてCARZYは消費税込みで販売価格を設定しています。</li>
                <li>自動車税・リサイクル券等の法定費用は月割りで精算いただくことが多いですが、原則的に売り主/買い主双方の協議によります。</li>
                <li>お支払いはCARZYのエスクローサービスをご利用いただくことでご安心してお取り引きいただくことができます。</li>
                <li>購入後の車両の引き渡し・陸送は買い主負担となります。また車両の名義変更費用も買い主負担となります。</li>
                <li>あくまでも個人間売買サービスという性質をよくご理解いただき、車両は現状渡し、ノークレームノーリターンとします。</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>

  <ng-template #underConstructionTemplate>
    <div class="under_construction">{{ lang | i18nSelect: strings.carDetail.underConstruction }}</div>
  </ng-template>
  <ng-template #carLoadingTemplate>

    <div class="fetch_loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>

      <div class="skeleton_box">
        <div class="skelton_upper">
          <div class="skeleton_main_photo"></div>
          <div class="swiper-my-pagination skeleton_thumbnails">
            <ng-container *ngFor="let i of skeletonThumbnailNumbers">
              <span class="swipter-pagination-bullet" (click)="slideTo(i)"><span class="car_thumbnail"></span></span>
            </ng-container>
          </div>
          <div class="skeleton_model_year"></div>
          <div class="skeleton_car_name"></div>
        </div>
        <div class="skeleton_copy"></div>
        <div class="skeleton_mini_border"></div>
        <div class="skeleton_desc_text" *ngFor="let number of skeletonDescNumbers"></div>
      </div>
    </div>
  </ng-template>

</app-layout>
